import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { onGetFullDmsList } from '../../../appRedux/actions';

export default function DmsFolderSearch() {
  const dispatch = useDispatch();
  const [searchFolder, setSearchFolder] = useState('');
  const onChangeFolderSerach = (e: string) => {
    setSearchFolder(e);
  };
  useEffect(() => {
    if (searchFolder !== '') {
      const delayRun = setTimeout(() => {
        dispatch(onGetFullDmsList(0, searchFolder, '', null));
      }, 1000);
      return () => clearTimeout(delayRun);
    }
  }, [searchFolder]);
  return (
    <div className={`gx-search-bar`}>
      <div className="gx-form-group">
        <input
          className="ant-input"
          type="search"
          placeholder={'جستجو'}
          onChange={(e) => {
            onChangeFolderSerach(e.target.value);
          }}
          value={searchFolder}
        />
        <span className="gx-search-icon gx-pointer">
          <i className="icon icon-search-new" />
        </span>
      </div>
    </div>
  );
}
